module.exports = __webpack_public_path__ + "static/MENU_2-9bbacb6803255752eb28614696fc3b89.png";